const sec2Time = (secTime) => {
  if (typeof secTime === 'string' && (secTime.includes('h') || secTime.includes('m') || secTime.includes('s'))) return secTime;
  const secondTime = parseFloat(secTime);
  if (isNaN(secondTime) || secondTime === 0) return "0s";
  const hours = Math.floor(secondTime / 3600);
  const minutes = Math.floor((secondTime - hours * 3600) / 60);
  const seconds = Math.floor(secondTime - hours * 3600 - minutes * 60);

  const hoursStr = hours === 0 ? `` : `${hours}h `;
  const minutesStr = minutes === 0 ? `` : `${minutes}m `;
  const secondsStr = seconds === 0 ? `` : `${seconds}s`;
  return (hoursStr + minutesStr + secondsStr).trim();
};

export default sec2Time;
